const initialState = [];

const SET_QUANTITY = 'PRODUCT/QUANTITY/SET_QUANTITY';
const SET_QUANTITY_ERROR = 'PRODUCT/QUANTITY/SET_QUANTITY_ERROR';

export type QuantityOption = {
  value: Number
};

export type StateQuantity = {
  value: Number,
  error: String
};

const setQuantityAction = (quantity: Number) => ({
  type: SET_QUANTITY,
  quantity
});

const setQuantityErrorAction = (error: null | string) => ({
  type: SET_QUANTITY_ERROR,
  error
});

export const setQuantity = (quantity: QuantityOption) => (
  dispatch: Function
) => {
  dispatch(setQuantityAction(quantity.value));
};

export const setQuantityError = (error: null | string) => (
  dispatch: Function
) => {
  dispatch(setQuantityErrorAction(error));
};

export default function reducer(
  state: Array = initialState,
  action: Object = {}
) {
  switch (action.type) {
    case SET_QUANTITY: {
      const quantity: StateQuantity = {
        ...state,
        value: action.quantity
      };
      return quantity;
    }
    case SET_QUANTITY_ERROR: {
      const quantity: StateQuantity = {
        ...state,
        error: action.error
      };
      return quantity;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/quantity.js